import { Skeleton } from './skeleton';

type TSkeletonCardProps = {
  className?: string;
};

export function SkeletonText({ className }: TSkeletonCardProps) {
  return <Skeleton className={`w-full h-[10px] bg-skeleton rounded-[8px] ${className} `} />;
}
